import DropdownItem, {
  DropdownItemProps,
} from "react-bootstrap/esm/DropdownItem";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

type Props = {
  id: string;
  description: string;
  className?: string;
  active?: boolean;
  onClick: DropdownItemProps["onClick"];
};
/**
 * renders note code (cpt / icd) menu item
 */
const NoteCodeMenuItem = ({
  id,
  description,
  className,
  active,
  onClick,
}: Props) => (
  <DropdownItem
    as={"button"}
    key={id}
    className={getClasses(
      styles["note-code-menu-item"],
      active && "active",
      className,
    )}
    active={active}
    onClick={onClick}
  >
    <div className={styles["note-code-menu-item__code"]}>{id}</div>
    <div className={styles["note-code-menu-item__description"]}>
      {description}
    </div>
  </DropdownItem>
);

export default NoteCodeMenuItem;
